import { Radio } from '~/eds/src/components/Radio/Radio';
import { Option } from '~/eds/src/types/Option';

interface Props<V = unknown> {
  disabled?: boolean;
  groupName: string;
  id: string;
  label: Option['label'];
  selectedValue: V;
  sublabel?: Option['info'];
  value: V;
  onChange: (value: V) => void;
}

const EcRadioButton = ({
  disabled = false,
  groupName,
  id,
  label,
  selectedValue,
  sublabel,
  value,
  onChange,
}: Props) => {
  const handleChange = () => {
    onChange(value);
  };

  return (
    <Radio
      value
      id={id}
      checked={selectedValue === value}
      name={groupName}
      disabled={disabled}
      option={{
        label: label,
        info: sublabel,
        value: value,
      }}
      onChange={handleChange}
    />
  );
};

export default EcRadioButton;
